module.exports = __webpack_public_path__ + "img/scroll.2d56c697.gif";